import * as types from "../const/types";

export const getLocation = () => {
  return {
    type: types.GET_CONFIG_LOCATION_BEGIN,
  };
};
